export default {
  // Graue allgemeine Notiz (laut PM-Video wiederhergestellt) — die vollständige "eins pro
  // Bestellung"-Regel, angezeigt im Angebots-Sheet und im Rabattcode/Geschenkkarten-Modal.
  // Automatische Rabatte (Smart Pricing) gelten weiterhin zusätzlich.
  general_note:
    'Rabattcodes und Geschenkkarten können nicht mit anderen Rabatten kombiniert werden. Ein Angebot und eine Punkte-Einlösung können zusammen genutzt werden. Automatische Rabatte wie der Abholrabatt gelten weiterhin.',
  // Full note — offer detail sheet + promo/gift entry (CTO shortened to one line, 2026-07-31).
  full_note: 'Rabattcodes und Geschenkkarten können nicht mit anderen Rabatten kombiniert werden.',
  // Grüne Status-Plakette im Angebots-Sheet, wenn die Angebotsbedingung erfüllt ist (Prototyp).
  unlocked: 'Freigeschaltet',
  // Short static exclusion note per surface (card footers, CTO-confirmed copy).
  footer: {
    offer: 'Nicht mit Rabattcodes oder Geschenkkarten kombinierbar.',
    promo: 'Nicht mit Angeboten, Geschenkkarten oder Punkten kombinierbar.',
    gift: 'Nicht mit Angeboten, Rabattcodes oder Punkten kombinierbar.',
  },
  // State-aware conflict line — names the discount that will be displaced.
  // Full mutual exclusivity (PM video): offer, promo, gift and points all block each other.
  conflict: {
    offer_blocked_by_promo: 'Ein Rabattcode ist aktiv. Wenn du dieses Angebot anwendest, wird er entfernt.',
    offer_blocked_by_gift: 'Eine Geschenkkarte ist aktiv. Wenn du dieses Angebot anwendest, wird sie entfernt.',
    offer_blocked_by_points: 'Eine Punkte-Einlösung ist aktiv. Wenn du dieses Angebot anwendest, wird sie entfernt.',
    promo_gift_displaces_offer:
      'Wenn du einen Rabattcode oder eine Geschenkkarte anwendest, wird dein aktives Angebot entfernt.',
    promo_gift_displaces_points:
      'Wenn du einen Rabattcode oder eine Geschenkkarte anwendest, wird deine Punkte-Einlösung entfernt.',
    promo_gift_displaces_offer_and_points:
      'Wenn du einen Rabattcode oder eine Geschenkkarte anwendest, werden dein aktives Angebot und deine Punkte-Einlösung entfernt.',
  },
  // Vergleichs-Auswahlkarte (Inc 4, FOO-2567) — Angebots-/Rabattcode-Detailmodal, wenn bereits ein
  // konkurrierender Rabatt aktiv ist. Die Kundin wählt; die höhere Ersparnis wird als beste markiert.
  comparison: {
    active_line: 'Dieses {{kind}} ist bereits aktiv: {{name}} ({{saving}}).',
    active_line_no_saving: 'Dieses {{kind}} ist bereits aktiv: {{name}}.',
    candidate_line: 'Der {{kind}} spart {{saving}}.',
    only_one: 'Du kannst nur eins verwenden.',
    best_choice: 'Beste Wahl',
    keep: '{{label}} behalten',
    use_instead: 'Stattdessen {{label}} verwenden',
    kinds: {
      offer: 'Angebot',
      promo: 'Rabattcode',
      gift: 'Geschenkkarte',
      points: 'Punkte-Einlösung',
    },
    // Kurze Nomen für die Behalten/Verwenden-Buttons ("Angebot behalten", "Stattdessen Code verwenden").
    button_kinds: {
      offer: 'Angebot',
      promo: 'Code',
      gift: 'Geschenkkarte',
      points: 'Punkte',
    },
    // Einzel-Aktion (Angebots-Modal, Rabattcode/Geschenkkarte bereits aktiv): ein Satz + nur der
    // "Stattdessen dieses Angebot"-Button — Fenster schließen behält den Code (CTO 2026-08-03).
    single_message:
      '{{active}} ist bereits aktiv. Pro Bestellung ist nur ein Rabatt möglich — nutze stattdessen dieses Angebot oder schließe das Fenster, um deinen Code zu behalten.',
    active_named: {
      promo: 'Rabattcode {{name}} ({{saving}})',
      gift: 'Geschenkkarte ({{saving}})',
    },
    active_named_no_saving: {
      promo: 'Rabattcode {{name}}',
      gift: 'Geschenkkarte',
    },
    // Mehrere aktive Angebote (Punkt 6) — Rabattcode-Modal-Vergleich, ersetzt aktive/kandidat-Zeilen.
    active_offers_two:
      'Du hast {{count}} aktive Angebote: {{first}} ({{firstValue}}) und {{second}} ({{secondValue}}) — zusammen {{total}}. Der Rabattcode {{code}} spart bei dieser Bestellung {{codeValue}}. Es kann nur eins verwendet werden.',
    active_offers_more:
      'Du hast {{count}} aktive Angebote: {{first}} ({{firstValue}}), {{second}} ({{secondValue}}) und {{more}} weitere — zusammen {{total}}. Der Rabattcode {{code}} spart bei dieser Bestellung {{codeValue}}. Es kann nur eins verwendet werden.',
  },
  // Discount-card-Status-Tag (Deals-Karussell — Angebots- + Rabattcode-Karten), Inc 3.
  card: {
    available: 'Jetzt verfügbar',
    applied: 'Angewendet · {{savings}} Rabatt',
    applied_plain: 'Angewendet',
    replaces: 'Nicht kombinierbar mit {{label}} · Ersetzt {{name}}',
    replaces_no_name: 'Nicht kombinierbar mit {{label}}',
    // Prototyp-Kartendarstellung (durch Konflikt blockiert): Warnzeile mit dem aktiven Rabatt,
    // die "eins pro Bestellung"-Notiz und eine "Ersetzt …"-Zeile.
    cannot_combine: 'Nicht kombinierbar mit {{name}}',
    replaces_name: 'Ersetzt {{name}}',
    // Mehrere aktive Angebote (n>1) — Anzahl + Summe statt eines einzelnen Namens (Punkt 6).
    cannot_combine_offers: 'Nicht kombinierbar mit deinen {{count}} aktiven Angeboten',
    replaces_offers: 'Ersetzt {{count}} aktive Angebote ({{total}})',
    // Generischer Typ-Label für den aktiven Rabatt, der ersetzt würde.
    kind: {
      offer: 'einem Angebot',
      promo: 'einem Rabattcode',
      gift: 'einer Geschenkkarte',
      points: 'deiner Punkte-Einlösung',
    },
  },
  // DisplacementNotice (Warenkorb + Checkout) — bidirektional & mit Namen (PM-Video).
  // Ein Rabatt hat einen anderen verdrängt; die Nachricht nennt beide, Undo stellt den
  // verdrängten wieder her. z. B. "Rabattcode CHEVERE angewendet. Dies hat das 2-für-1-Angebot entfernt. [Rückgängig]".
  displacement: {
    message: '{{applied}} angewendet. Dies hat {{removed}} entfernt.',
    // Mehrere Angebote gleichzeitig entfernt (Punkt 6) — nennt die zwei größten + die Summe.
    offer_removed_multi: {
      promo:
        'Rabattcode {{code}} ({{codeValue}}) angewendet. {{count}} Angebote wurden dadurch entfernt: {{first}} und {{second}} ({{total}}).',
      gift: 'Geschenkkarte angewendet. {{count}} Angebote wurden dadurch entfernt: {{first}} und {{second}} ({{total}}).',
    },
    undo: 'Rückgängig',
    // Der aktuell angewendete Rabatt (der "Gewinner").
    applied: {
      offer: 'Angebot {{name}}',
      promo: 'Rabattcode {{code}}',
      gift: 'Geschenkkarte',
      points: '{{count}} Punkte',
    },
    // Der verdrängte Rabatt (der "Verlierer"), den Undo wiederherstellt.
    removed: {
      offer: 'das Angebot {{name}}',
      promo: 'den Rabattcode {{code}}',
      gift: 'die Geschenkkarte',
      points: 'deine Punkte-Einlösung',
    },
    // UX-Feedback Punkt 3 — Punkte-Einlösung verdrängt Rabattcode/Geschenkkarte. Ebene A: dezenter
    // Hinweis unter der "Punkte einlösen"-Überschrift, nur solange ein Code/Geschenkkarte aktiv ist.
    points_hint: {
      promo: 'Punkte einzulösen entfernt den Rabattcode {{name}} (–{{saving}})',
      gift: 'Punkte einzulösen entfernt die Geschenkkarte (–{{saving}})',
      promo_no_saving: 'Punkte einzulösen entfernt den Rabattcode {{name}}',
      gift_no_saving: 'Punkte einzulösen entfernt die Geschenkkarte',
    },
    // Ebene B: die Verdrängungs-Notiz, erweitert um die Richtung Punkte→Code.
    points_displaced: {
      promo: '{{points}} Punkte eingelöst (–{{pointsSaving}}). Rabattcode {{name}} (–{{couponSaving}}) wurde entfernt.',
      gift: '{{points}} Punkte eingelöst (–{{pointsSaving}}). Geschenkkarte (–{{couponSaving}}) wurde entfernt.',
      promo_no_saving: '{{points}} Punkte eingelöst (–{{pointsSaving}}). Rabattcode {{name}} wurde entfernt.',
      gift_no_saving: '{{points}} Punkte eingelöst (–{{pointsSaving}}). Geschenkkarte wurde entfernt.',
    },
  },
};
